import React from 'react';

import Modal from '../../shared/components/modal';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import { withError } from '../../shared/components/error-boundary';
import Link from '../../shared/components/hyperlink';
import { Helpers } from "../../core/src/helpers";
import AccessibleElement from '../../ui/components/accessible-element';

import '../css/utility-nav.less';

const EMPTY_OBJ = {};

class UtilityNav extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showMenu: false,
			modalOpen: false,
			setIframe: false,
			callCenter: {
				manageLock: false,
				message: "",
				displayMsg: false
			}
		};
		this.openMenu = this.openMenu.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.helpModalContent = this.helpModalContent.bind(this);
		this.manageLock = this.manageLock.bind(this);
	}

	componentDidMount() {
		//only fetch if not already updated from service
		const { updatedFromService } = this.props;
		if (!updatedFromService) {
			this.props.fetchUtility();
		}
	}

	static getDerivedStateFromProps(nextProps, state) {
		if (nextProps.callCenter && nextProps.callCenter.orderLock && state.callCenter.manageLock) {
			return ({
				"callCenter": Object.assign(this.state.callCenter, {
					manageLock: false,
					modalOpen: true,
					message: nextProps.callCenter.orderLock.message
				})
			});
		}
		return null;
	}

	openMenu(e) {
		e.preventDefault();
		const { showMenu } = this.state;
		if ((window.innerWidth || window.screen.availWidth) <= 800) {
			this.setState({ showMenu: !showMenu, modalOpen: true });
		} else {
			this.setState({ showMenu: !showMenu })
		};
	}

	openModal(loadIframe) {
		//iframe will only be set the first time the modal open
		this.setState({ modalOpen: true, showMenu: false, setIframe: this.state.setIframe || loadIframe });
	}

	closeModal() {
		this.setState({
			modalOpen: false, showMenu: false, "callCenter": Object.assign(this.state.callCenter,
				{
					modalOpen: false,
					message: ""
				})
		});
	}

	getCustomerCareNumber(label) {
		try {
			let text = Helpers.decodeHtml(label);
			let tempDiv = document.createElement("div");
			tempDiv.innerHTML = text;
			let [, number = ""] = tempDiv.textContent.split("Sales:");
			return number.trim().match(/[\d|-]+/ig)[0];
		} catch (e) {
			return "1-866-625-3906"
		}
	}

	createInput(name, value) {
		let input = document.createElement('input')
		input.type = "hidden";
		input.name = name;
		input.value = value;
		return input;
	}

	manageLock(action) {
		this.setState({
			"callCenter": Object.assign(this.state.callCenter,
				{
					manageLock: true,
					modalOpen: true
				})
		});
		this.props.manageOrderLock(action);
	}

	dropDownItems(forMobile) {
		let p = this.props.profileData;
		let pStoreID = (p.personData || EMPTY_OBJ).pStoreID;
		let withRegisteredPrinter = p['personData']['printersData'];
		let classes = "lastBox topmenuchild" + (this.state.showMenu ? " showMenu" : "") + (forMobile ? "" : " hide-mobile") + (withRegisteredPrinter ? ' with-registeredPrinter' : '');
		let loggedInItems = [["logoutUrl", "lblLogout"], ["myAccountUrl", "lblMyAccount"], ["orderHistoryUrl", "lblMyOrders"], ['manageMyDeviceCCUrl', 'lblMyDevices'], withRegisteredPrinter ? ["personData", "printersData"] : [], ["newsletterSubsribeUrl", "lblNewsReg"]];
		let loggedOutItems = [["logonUrl", "lblSignin"], ["registerUrl", "lblRegister"], ["orderHistoryUrl", "lblMyOrders"], ['manageMyDeviceUrl', 'lblMyDevices'], ["newsletterSubsribeUrl", "lblNewsReg"]];
		let itemList = (p.personData.isLoggedIn && p.personData.hpiddata ? loggedInItems : loggedOutItems);

		return (
			<ul className={classes} onMouseLeave={(e) => this.closeModal()}>
				{itemList.map((item, idx) => {
					const [valKey, lblKey] = item;
					const lnkLabel = p.labels[lblKey];
					let linkUrl = Helpers.decodeHtml(p[valKey]);
					if (pStoreID) {				
						linkUrl  = Helpers.addUrlParam(linkUrl, { pStoreID })
					}
					if (item[0] === 'personData' && p[item[0]][item[1]]) {
						let printerList = p[item[0]][item[1]];
						return (
							<li className="savedPrinterList" key={idx}>
								<div>Buy ink or toner for my latest printer(s)</div>
								<ul>
									{printerList.map((printer, i) => (
										<li key={i}>
											<a href={Helpers.decodeHtml(printer["printerUrl"])} aria-label={printer["printerName"]}>
												<img src={Helpers.decodeHtml(printer["printerImg"])} />
												<span>{printer["printerName"]}</span>
											</a>
										</li>
									))}
								</ul>
							</li>
						)
					}
					else if (lnkLabel && linkUrl) {
						return (<li key={`${idx}-${linkUrl}`}><a aria-label={`${lnkLabel}`} href={linkUrl}>{lnkLabel}</a></li>)
					}
				})}
			</ul>)
	}


	helpModalContent() {
		const p = this.props.profileData || EMPTY_OBJ;
		const pStoreID = (p.personData || EMPTY_OBJ).pStoreID;
		const pStoreQueryParam = pStoreID ? `&pStoreID=${pStoreID }`: '';
		//set iframe on first open
		return (
			<div>
				<ul className="help-menu hide-desktop">
					<li><a href={`${process.env.BASENAME}/ContentView?eSpotName=CustomerService&catalogId=10051&langId=-1&storeId=10151${pStoreQueryParam}`}>{p.labels.cutomerService}</a></li>
					<li className="user-phone"><a><span className="sales-text">Sales: </span>{this.getCustomerCareNumber(p.labels.customerCarePhone)}</a></li>
					<li><a href={`${process.env.BASENAME}/MyAccountOrderStatusView?catalogId=10051&langId=-1&storeId=10151${pStoreQueryParam}`}>Order Status</a></li>
				</ul>

				<div className="live-help-overlay hide-mobile">
					<iframe className="live-help" src={this.state.setIframe ? `${process.env.BASENAME}/LiveHelpView?storeId=10151&langId=-1&catalogId=10051&pagelevel=Home%20Page${pStoreQueryParam}` : ""}></iframe>
				</div>
			</div>
		);
	}

	renderDropDown(psn) {
		let p = this.props.profileData || EMPTY_OBJ;
		let loggedIn = p.personData.isLoggedIn && p.personData.hpiddata;
		let dropDownMenuTitle = loggedIn ? "Welcome, " + p.personData.firstname : p.labels.lblSigninRegister;
		return (
			<li className="lastItemInList hasdropdown mobile-menu-item">
				<AccessibleElement
					element="a"
					ariaLabel="Categories Menu"
					className="mainLink downDisclosure arrow-down hp-icon page-down"
					onClick={this.openMenu}
				>
					<span aria-label={dropDownMenuTitle} className="hide-mobile">{dropDownMenuTitle}</span>
					<span className="hide-desktop">{loggedIn ? "Welcome, " + p.personData.firstname : "My Account"}</span>
					<i></i>
				</AccessibleElement>
				{this.dropDownItems()}
			</li>
		)
	}

	renderNav() {
		return (
			<section className="topmenu">
				{ this.renderLeftNav()}
				{ this.renderRightNav()}
			</section>
		)
	}

	renderRightNav() {
		const p = this.props.profileData || EMPTY_OBJ;
		const pStoreID = (p.personData || EMPTY_OBJ).pStoreID;
		const pStoreQueryParam = pStoreID ? `&pStoreID=${pStoreID }`: '';
		let psn = (p.psn ? <li className="psn hide-mobile">
			<ImageWithPlaceholder src={p.personData.eppCompanyLogoUrl} />
			<div>{p.psn}</div>
		</li> : null);

		return (
			<ul className="right">
				{ psn}
				<li tabIndex={0} aria-label="1-866-625-3906" className="hide-mobile">
					{p.personData.custSeg === 'CG_gs' && <span className="sales-text">Sales: </span>}
					<span>
						{'1-866-625-3906'}
					</span>
				</li>
				{!p.personData.custSeg === 'CG_gs' &&
					<li>
						<a className="hide-mobile"
							aria-label="Order Status"
							href={`${process.env.BASENAME}/MyAccountOrderStatusView?catalogId=10051&langId=-1&storeId=10151${pStoreQueryParam}`}>
							Order Status
						</a>
					</li>
				}
				<li className="hide-mobile">
					<a href={`${process.env.BASENAME}/LiveHelpView?catalogId=10051&langId=-1&storeId=10151${pStoreQueryParam}`}
						className="mainLink js_overlay_trigger"
						aria-label={p.labels.lblNeedHelp || 'Need help?'}>{p.labels.lblNeedHelp || 'Need help?'}</a>
				</li>
				<li className="hide-mobile"><a aria-label={p.labels.cutomerService} href={`${process.env.BASENAME}/ContentView?eSpotName=CustomerService&catalogId=10051&langId=-1&storeId=10151${pStoreQueryParam}`}>{p.labels.cutomerService}</a></li>
				{ p.personData.custSeg === 'CG_gs' && p.labels.hpRewards &&
					<li className="hide-mobile">
						<a aria-label={p.labels.hpRewards} href={`${process.env.BASENAME}/LoadLoyaltyLandingPageCmd?catalogId=10051&userTyp=G&storeId=10151${pStoreQueryParam}`}>
							{p.labels.hpRewards}
						</a>
					</li>
				}
				{this.renderDropDown(psn)}
				<li className="hide-desktop mobile-menu-item"
					onClick={() => this.openModal(false)}>
					<a className="helpLink hp-icon page-down">{p.labels.lblNeedHelp || 'Need help?'}<i></i></a>
				</li>
			</ul>
		)
	}

	renderLeftNav() {
		const p = this.props.profileData || EMPTY_OBJ;
		const pStoreID = (p.personData || EMPTY_OBJ).pStoreID;
		const pStoreQueryParam = pStoreID ? `?pStoreID=${pStoreID }`: '';
		return (
			<ul className="left-nav">
				<li className="store-link"><a aria-label="HP Store" href={`${process.env.BASENAME}${pStoreQueryParam}`}>HP Store</a></li>
			</ul>
		)
	}

	renderPunchOut() {
		let p = this.props.profileData;

		let storeName = p.personData.storeName || p.personData.hpEmpStore;
		return (
			<div>
				<section className="topmenu punchout">
					<ul className="right">
						<li><span>Welcome, &nbsp; <a>{p.personData.agentLogonId}</a></span></li>
						<li><a onClick={(e) => this.manageLock('A')}>{p.labels.lblAcquireLock || "Acquire Lock"}</a></li>
						<li><a onClick={(e) => this.manageLock('R')}>{p.labels.lblReleaseLock || "Release Lock"}</a></li>

						{p.personData.customerLogonId ? null : <li><a href={Helpers.decodeHtml(p.ccCreateUserUrl)}>{p.labels.lblCreateUser || "Create User"}</a></li>}
						{p.personData.customerLogonId ?
							<li><a href={Helpers.decodeHtml(p.ccEndCurrentCustomerSessionUrl)}>End Current Customer</a></li> :
							<li><a href={Helpers.decodeHtml(p.ccSearchUserUrl)}>{p.labels.lblSearchUser || "Search User"}</a></li>}
						<li><a href={Helpers.decodeHtml(p.ccEndCallUrl)}>{p.labels.lblClosePunchout || "Close Punchout"}</a></li>

					</ul>
				</section>
				<section className="topmenu punchout">
					<ul className="right">
						{storeName ? <li><strong>{storeName}</strong></li> : null}
						<h3><li>Customer: &nbsp;<a>{p.personData.firstname}&nbsp;{p.personData.lastname}&nbsp; ({p.personData.customerLogonId})</a></li></h3>
					</ul>
				</section>
			</div>
		)
	}

	render() {
		let p = this.props.profileData || EMPTY_OBJ;
		return (
			<div className={"utilityNav" + (p.isccf ? " punchout" : "")}>
				<div className="login-container">
					<Link className='m_back hp-icon page-left' to={process.env.BASENAME}>HP Store</Link>
					{p.isccf ? this.renderPunchOut() : this.renderNav()}
				</div>
				<Modal modalContent={this.state.showMenu ? this.dropDownItems(true) : this.helpModalContent()} isOpen={this.state.modalOpen} closeModal={this.closeModal} />
				<Modal modalContent={this.state.callCenter.message} isOpen={this.state.callCenter.modalOpen} closeModal={this.closeModal} />
			</div>
		)
	}
}

export default withError(UtilityNav);
